import { render, staticRenderFns } from "./ProducersTablePrice.vue?vue&type=template&id=6535a6f0&"
import script from "./ProducersTablePrice.vue?vue&type=script&lang=js&"
export * from "./ProducersTablePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports